import { forwardRef } from 'react';
import type { GlobalAlert } from '../../api/globalAlerts.types';
import './GlobalAlerts.scss';
import { RenderAlertWithAnchors } from './RenderAlertWithAnchors';

const ALERT_TIMEOUT = 1000; // Dismiss from DOM after 1s to allow CSS transitions

type GlobalAlertsProps = {
  alerts: Array<GlobalAlert>;
  onDismiss: (id: string) => void;
  baseUrl?: string;
};

const GlobalAlerts = forwardRef<HTMLDivElement, GlobalAlertsProps>(function GlobalAlerts(
  { alerts, onDismiss, baseUrl },
  ref
) {
  if (!alerts?.length) return null;

  const handleDismiss = (alert: GlobalAlert): void => {
    if (!alert?.dismissible) return;
    setTimeout(() => onDismiss(alert.id), ALERT_TIMEOUT);
  };

  return (
    <div ref={ref} className="wdh-global-alerts">
      <div className="bom-alerts">
        <div className="bom-alerts__container">
          {alerts.map((alert, idx) => (
            <RenderAlertWithAnchors key={`a-${idx}`} alert={alert} baseUrl={baseUrl} onDismiss={handleDismiss} />
          ))}
        </div>
      </div>
    </div>
  );
});

export default GlobalAlerts;
